export default theme => ({
  root: {},
  tableRow: {
    cursor: 'pointer'
  },
  tableCell: {
    whiteSpace: 'nowrap'
  },
  tableCellInner: {
    display: 'flex',
    alignItems: 'center'
  },
  textField: {
    width: '100%',
    marginTop: theme.spacing.unit * 2,
  },
  nameText: {
    display: 'inline-block',
    marginLeft: theme.spacing.unit * 2,
    fontWeight: 500,
    cursor: 'pointer'
  },
  fieldError: {
    width: '100%',
    color: theme.palette.danger.main,
    marginBottom: theme.spacing.unit * 2,
    marginTop: theme.spacing.unit
  },
  licenseDialog: {
    width: '100%'
  },
  newEntryButton: {
    marginLeft: theme.spacing.unit
  },
  item: {
    height: '100%',
    width: '100%'
  },
  status: {
    marginRight: theme.spacing.unit
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },
});
